import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SubscriptionMgmtListComponent } from './subscription-mgmt-list.component';

const routes: Routes = [
  {
    path: '',
    component: SubscriptionMgmtListComponent,
    title: 'Subscription'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubscriptionMgmtRoutingModule { }
